export default __webpack_public_path__ + "static/media/vertical-logo.843809fe.svg";